import {Component, OnInit, Input, Inject, EventEmitter, Output} from 'ng-metadata/core';

const _orderBy = require('lodash/orderBy');

@Component({
    selector: 'prm-multi-select-filter',
    templateUrl: 'components/search/fullView/ngrs/multiSelectFilter/multi-select-filter.html'
})


export class PrmMultiSelectFilter implements OnInit{

    @Input() filterLabel: string;
    @Input() filterOptions;
    @Input() filterValues: Object[];
    private previousFilterValues: Object[] = [];

    @Output() private valuesChange = new EventEmitter();




    constructor(@Inject('$translate') private $translate){
    }

    ngOnInit() {
        let all = {"key":'nui.librarycard.request.filter_value_all',"value": '+all'};

        let getOptionTranslation = (option) => {
            let translate = this.$translate.instant(option.key);
            return translate;
        };

        let orderedOptions = this.filterOptions;
        orderedOptions = orderedOptions.filter(function( obj ) {return obj.value !== '+all';});
        orderedOptions = _orderBy(orderedOptions, [getOptionTranslation], 'asc');
        orderedOptions.unshift(all);
        this.filterOptions = orderedOptions;
    }

    public changeFilter(){
        if(!this.filterValues){
            this.filterValues = [];
        }

        // All is checked and then all is selected
        if(this.previousFilterValues.indexOf('+all') > -1 && this.filterValues.length === 0){
            this.filterValues = ['+all'];
        }

		// All isn't checked then we deselct all other options
        else if(this.previousFilterValues.length > 0 && this.filterValues.length === 0){
            this.filterValues = ['+all'];
        }
        
        // All is checked then a different value is selected
        else if((this.previousFilterValues.indexOf('+all') > -1 && this.filterValues.indexOf('+all') > -1) && this.filterValues.length > 1){
            this.filterValues = this.filterValues.filter((option)=>{
                return option !== '+all';
            });
        }
        
        // All isn't checked then all is selected
        else if(this.filterValues.length > 1 && this.filterValues.indexOf('+all') > -1){
            this.filterValues = ['+all'];
        }

        this.previousFilterValues = this.filterValues;
        this.valuesChange.emit(this.filterValues);
    }

    public isSelected(option:string){
        if(this.filterValues && this.filterValues.indexOf('+' + option) > -1){
            return true;
        }
        return false;
    }

    public selectAll(){
        if(this.filterValues && this.filterValues.length === 0){
            this.filterValues = ['+all'];
            this.previousFilterValues = ['+all'];
        }
    }

    public getSortedFilterOption(){
        return this.filterOptions;
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/ngrs/multiSelectFilter/multiSelectFilter.directive.ts